import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/firefighter-trainingfirefighters-prepare-equipment-from-fire-trucks-fire-hose-drills-factory_38161-2057.jpg';

function FireAndRescue() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Fire and Rescue Services" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Fire and Rescue Services</h4>
              <p>
                This sub-department provides essential emergency response services for fires, hazardous material incidents, and rescue operations.<br />
                Our team of trained professionals is equipped to handle a variety of emergencies, ensuring the safety and well-being of the community.<br /><br />
                Through proactive training, state-of-the-art equipment, and community outreach, we aim to minimize the impact of disasters and protect lives.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Fire Suppression and Control</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Hazardous Materials Management</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Search and Rescue Operations</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to protecting lives, property, and the environment through rapid emergency response and preventive safety measures.
              </p>
            </div>
            <div>
              <Link to="/department/public-safety">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default FireAndRescue;
